import Loading from 'shared/components/Loading';

const LoadingIcon = props => {
  const {
    dataGrid,
    loadingMessage
  } = props;

  if (!dataGrid.loading) {
    return null;
  }

  const style = {
    position: 'absolute',
    zIndex: 99999,
    top: 0,
    textAlign: 'center',
    marginTop: '8rem'
  }

  const msgStyle = {
    fontFamily: 'sans-serif !important',
    fontSize: '1rem',
    marginTop: '1rem'
  }

  return <Loading style={style} messageStyle={msgStyle} message={loadingMessage} />;
}

export default LoadingIcon;
